import {Component, OnInit} from '@angular/core';
import {Bot} from "../../models/bot";
import {Language, LanguageToString, SettingsManagerService} from "../../services/settings-manager.service";
import {TranslateService} from "@ngx-translate/core";
import {CartographicConsoleConfig} from "../../models/cartographic-console-config";

@Component({
  selector: 'app-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss']
})
export class SettingsPageComponent implements OnInit {

  isLoading: boolean = true;

  bot: Bot;
  cartographicConsoleConfig: CartographicConsoleConfig;
  language: string;

  constructor(
    private settingsManagerService: SettingsManagerService,
    public translateService: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    this.bot = await this.settingsManagerService.getBotConfig();
    this.cartographicConsoleConfig = await this.settingsManagerService.getCartographicConsoleConfig();
    this.language = this.settingsManagerService.getLanguage();
    this.isLoading = false;
  }

  async save() {
    this.isLoading = true;
    this.settingsManagerService.setLanguage(this.language);
    await this.settingsManagerService.setBotConfig(this.bot);
    await this.settingsManagerService.setCartographicConsoleConfig(this.cartographicConsoleConfig);
    this.isLoading = false;
  }

  get LanguageToString() { return LanguageToString }

}
